<template>
  <section id="Map" class="g_section">
    <div class="g_bg_text opposite">
      <KinesisScroll
        tag="img"
        :src="'./static/hd_map.svg'"
        :strength="100"
        type="translate"
        axis="y"
      />
    </div>
    <div class="g_hd_en_wrap">
      <FxText>
        <p class="g_hd_en">LOCATION MAP</p>
      </FxText>
    </div>
    <div class="g_hd_ja_wrap">
      <FxText>
        <h2 class="g_hd_ja">会場マップ</h2>
      </FxText>
    </div>
    <div class="content_body">
      <p class="sp_notice">
        <img src="../../assets/icon_pinchout.svg" alt="" />
        画面を拡大してご覧ください
      </p>
      <div class="g_frame -padding_botton sp_map">
        <div class="map">
          <img src="../../assets/img_map.png" alt="会場マップ" />
        </div>
        <p class="caption">
          <img
            src="../../assets/icon_vcc.png"
            alt="VCC(バーチャルキャストクレジット)"
          />このマークの付いているショップでは、<a
            href="#Outline"
            v-scroll-to="'#Outline'"
            >VCC</a
          >を使って購入体験を楽しめます<br />
          ※ 各会場の入場人数には制限があります。
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import FxText from "../atoms/FxText";
import { KinesisScroll } from "vue-kinesis";
export default {
  name: "Map",
  components: { KinesisScroll, FxText }
};
</script>

<style scoped>
.map img {
  width: 100%;
}
.caption {
  margin: 1rem 0 0;
}
.caption img {
  width: auto;
}
.-padding_botton {
  padding-bottom: 20px;
}
.caption a {
  font-weight: bold;
  color: #fff;
}
.sp_notice {
  display: none;
}
@media screen and (max-width: 500px) {
  .sp_map {
    padding: 0;
  }
  .sp_notice {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sp_notice img {
    margin: 0 4px 0 0;
  }
  .caption {
    font-size: 0.8rem;
    margin: 1rem 0.5rem 1rem 1rem;
  }
  .caption img {
    width: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheMapSection.vue